import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { SelectItem } from '@bn/primitives';
import { SanitizeHtmlPipe } from '@bn/shared/core/pipes/sanitize-html.pipe';

import { ButtonComponent } from '../../../button/button.component';
import { AbstractDialogDirective } from '../../../dialog/abstracts';
import { MarkAllTouchedDirective } from '../../../directives/mark-all-touched.directive';
import { PrimeSelectComponent } from '../../../standalone/selects/prime-select/prime-select.component';
import { ModalState } from '../../models/modal-state.model';

@Component({
  selector: 'bn-web-ui-dashboard-select-input-dialog',
  templateUrl: './select-input-dialog.component.html',
  styleUrls: ['./select-input-dialog.component.scss'],
  imports: [FormsModule, MarkAllTouchedDirective, ReactiveFormsModule, FaIconComponent, PrimeSelectComponent, ButtonComponent, SanitizeHtmlPipe],
})
export class BnSelectInputDialogComponent extends AbstractDialogDirective implements OnInit {
  readonly bsModalRef = inject(BsModalRef);
  readonly BsModalService = inject(BsModalService);

  readonly #defaultValidators: ValidatorFn[] = [Validators.required];
  #parentEntity!: unknown;

  public isLoading = false;
  public inputSettings?: ModalState['input'];
  public selectDialogForm = new UntypedFormGroup({
    selectedValue: new UntypedFormControl(undefined, this.#defaultValidators),
  });
  public selectItems: SelectItem[] = [];
  virtualScrollConfig?: any;

  ngOnInit(): void {
    const validators = this.data.input?.validators || this.#defaultValidators;
    this.selectDialogForm.get('selectedValue')?.setValidators(validators);
    this.selectDialogForm.get('selectedValue')?.setValue(this.data.input?.value);
  }

  public onSubmit(): void {
    if (this.selectDialogForm.invalid || this.isLoading) return;
    const id = this.selectDialogForm?.value?.selectedValue;

    this.isLoading = true;
    this.onAction.next({
      action: 'save',
      itemId: id,
      data: { entity: this.#parentEntity },
    });
  }

  onCloseDialog(): void {
    this.onAction.next({ action: 'cancel' });
  }

  protected onDataInit(): void {
    this.inputSettings = this.data.input;
    this.#parentEntity = this.data.parentEntity;
    this.virtualScrollConfig = this.data.virtualScrollConfig;
    this.selectItems = this.data?.items ? (this.data.items as SelectItem[]).filter((item) => item.Id !== this.data?.item) : [];
  }
}
